import { combineReducers } from 'redux';
import counterReducer from './counterReducer';
import loginReducer from './loginReducer';
import alertReducer from './alertReducer';
import cartReducer from './cartReducer';
import storeReducer from './storeReducer';
import userReducer from './userReducer';
import productReducer from './productReducer';
import facilityReducer from './facilityReducer';
import categoryReducer from './categoryReducer';
import orderReducer from './orderReducer';
import searchReducer from './searchReducer';
import salesReducer from './salesReducer';
import priceGroupReducer from './priceGroupReducer';

const rootReducer = combineReducers({
	counter: counterReducer,
	auth: loginReducer,
	alert: alertReducer,
	cart: cartReducer,
	products: storeReducer,
	user: userReducer,
	adminProducts: productReducer,
	facilities: facilityReducer,
	categories: categoryReducer,
	order: orderReducer,
	search: searchReducer,
	sales: salesReducer,
	priceGroups: priceGroupReducer,
});

export default rootReducer;
